import React from "react";
import {
  Typography,
  Container,
  Grid,
  Card,
  CardMedia,
  CardContent,
  Box,
} from "@mui/material";
import ImageCarousel from "../ImageCarousel";
import KSLocations from "../ServingLocations";
import StatsSection from "../StatsSection";
import CustomerReviews from "../reviews";
import FounderSection from "../FounderSection";

const Home = () => (
  <>
    <Box sx={{ backgroundColor: "#FFF8E1", py: 10, textAlign: "center" }}>
      <Container maxWidth={false}>
        <ImageCarousel />
      </Container>
    </Box>

    <KSLocations />
    <StatsSection />
    <CustomerReviews />
    <FounderSection />
  </>
);

export default Home;
